<template>
  <div class="classroom-edit">
    <el-dialog
      title="修改课室"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="480px"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="课室号:" prop="classroomCode">
                <el-input
                  v-model="ruleForm.classroomCode"
                  placeholder="请输入课室号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="课室名称:" prop="classroomName">
                <el-input
                  v-model="ruleForm.classroomName"
                  placeholder="请输入课室名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- <div class="beaconCode">
          <div class="text">信标（可输入查找）:</div>
          <el-select
            v-model="beaconCodeList"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入信标"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in beaconSelect"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="comfrim('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    classroomInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject: ["refresh"],
  created() {},
  data() {
    return {
      // allBeaconList 假设为数据库所有数据
      allBeaconList: [
        {
          id: 3,
          createBy: "1",
          createTime: "2021-07-09 11:51:40",
          updateBy: "1",
          updateTime: "2021-10-10 14:15:08",
          remark: "",
          delFlag: "0",
          status: "0",
          searchValue: null,
          params: {},
          schoolId: 1,
          schoolName: "天河第一中学",
          beaconCode: "80:ec:ca:cd:8d:af",
        },
        {
          id: 15,
          createBy: "1",
          createTime: "2022-02-10 17:59:27",
          updateBy: null,
          updateTime: null,
          remark: null,
          delFlag: null,
          status: null,
          searchValue: null,
          params: {},
          schoolId: 1,
          schoolName: "广州市长兴中学",
          beaconCode: "a1:b1:c1:d1.e1",
        },
        {
          id: 16,
          createBy: "1",
          createTime: "2022-02-10 17:59:27",
          updateBy: null,
          updateTime: null,
          remark: null,
          delFlag: null,
          status: null,
          searchValue: null,
          params: {},
          schoolId: 1,
          schoolName: "广州市长兴中学",
          beaconCode: "a1:b1:c1:d1.e2",
        },
        {
          id: 17,
          createBy: "1",
          createTime: "2022-02-10 17:59:27",
          updateBy: null,
          updateTime: null,
          remark: null,
          delFlag: null,
          status: null,
          searchValue: null,
          params: {},
          schoolId: 1,
          schoolName: "广州市长兴中学",
          beaconCode: "a1:b1:c1:d1.e3",
        },
      ],
      // 下拉框的选择列表（全，不显示）（根据数据库获取到的列表转换而来，可以设置value和label的值）
      allBeaconSelect: [], // 好像没有必要
      // 下拉框显示的选择列表（根据搜索条件显示）
      beaconSelect: [],
      // 选中的信标列表
      beaconCodeList: [],

      loading: false, // 控制加载效果

      ruleForm: {
        classroomCode: "",
        classroomName: "",
        beaconCode: "",
      },
      rules: {
        classroomCode: [{ required: true, message: "请输入课室号", trigger: "blur" }],
        classroomName: [{ required: true, message: "请输入课室地址", trigger: "change" }],
      },
      formLabelWidth: "120px",
      inputVisible: false,
      inputValue: "",
    };
  },
  mounted() {
    this.allBeaconSelect = this.allBeaconList.map((item) => {
      return {
        value: `${item.beaconCode}`,
        // value: `${item.id}&${item.beaconCode}`,
        label: `${item.beaconCode}`,
      };
    });
  },
  methods: {
    // dialog 打开
    dialogOpen() {
      let {
        classroomCode,
        classroomName,
        beaconCode,
        beaconCodeList,
      } = this.classroomInfo;
      this.ruleForm.classroomCode = classroomCode;
      this.ruleForm.classroomName = classroomName;
      this.ruleForm.beaconCode = beaconCode;
      this.beaconCodeList = beaconCodeList;
    },
    // dialog 关闭
    dialogClose() {
      let {
        classroomCode,
        classroomName,
        beaconCode,
        beaconCodeList,
      } = this.classroomInfo;
      this.ruleForm.classroomCode = classroomCode;
      this.ruleForm.classroomName = classroomName;
      this.ruleForm.beaconCode = beaconCode;
      this.beaconCodeList = beaconCodeList;
      this.$emit("update:dialogVisible", false);
    },
    // 远程搜索方法
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        // 调用接口模糊查找，更新this.beaconSelect
        setTimeout(() => {
          this.loading = false;
          this.beaconSelect = this.allBeaconSelect.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.beaconSelect = [];
      }
    },
    comfrim(formName) {
      // console.log("this.beaconCodeList=>", this.beaconCodeList);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (!this.beaconCodeList.length) {
          //   return this.$message.error("信标不能为空");
          // }
          // console.log("验证成功,下一步");
          // this.ruleForm.beaconCode = this.beaconCodeList.join(",");
          // console.log("ruleForm=> ", this.ruleForm);
          // console.log("classroomInfo=> ", this.classroomInfo);
          let { classroomCode, classroomName, beaconCode } = this.ruleForm;
          let { id: updateBy, schoolId, schoolName } = this.user;
          let submit = {
            id: this.classroomInfo.id,
            updateBy,
            schoolId,
            schoolName,
            classroomCode,
            classroomName,
          };
          // 调用接口修改教室信息
          // 调用接口，成功后刷新 this.refresh()
          // console.log(submit);
          this.put(this.$url.putClassroom, submit)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("修改失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },
    // 信标相关
    handleClose(tag) {
      this.beaconCodeList.splice(this.beaconCodeList.indexOf(tag), 1);
      // console.log(this.beaconCodeList);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.beaconCodeList.push(inputValue);
        // console.log(this.beaconCodeList);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./classroom-edit.scss";
</style>
